module.exports = __webpack_public_path__ + "static/img/youtube_available.90858c2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/youtube_available.svg
// module id = 1RGA
// module chunks = 1